// extracted by mini-css-extract-plugin
module.exports = {"section":"LuLCVNWOBJd2XJQL_p6O","sectionContent":"D6BJyEfa8Pok6tT10Ytk","sectionHeader":"v1ugtRefGgPYZgN5rL_W"};